import { FaFacebookF } from '@react-icons/all-files/fa/FaFacebookF';
import { FaInstagram } from '@react-icons/all-files/fa/FaInstagram';
import React, { useContext } from 'react';

import ColorContext from '../../context/ColorContext';
import compact from '../../utils/helpers/compact';
import { tw } from '../../utils/tailwind';
import Cart from '../Cart/Cart';
import { Stack } from '../Core';
import { Flex } from '../Core/Flex';
import MenuItem from '../MenuItem';

interface ITopMenuProps {
  currentPath: string;
  menuData: MenusData['topmenu'];
  showSnipcart?: boolean;
}

const TopMenu: FCWithClassName<ITopMenuProps> = (props) => {
  const colorContext = useContext(ColorContext);
  const color = 'white';
  const serializedLinks = compact(
    props.menuData.map((menuItem) => {
      if (menuItem.label !== 'FB' && menuItem.label !== 'IG') {
        return (
          <MenuItem
            currentPath={props.currentPath}
            key={menuItem.id}
            menuItem={menuItem}
            menuType="desktop"
            color={color}
            className="hover:!text-white"
          />
        );
      }
      return null;
    })
  );
  const serializedSocialLinks = compact(
    props.menuData.map((menuItem) => {
      if (menuItem.label === 'FB') {
        return (
          <a
            key={menuItem.id}
            href={menuItem.url ?? undefined}
            style={{ color }}
            target="_blank"
            rel="noopener noreferrer"
            className="border-b-0"
          >
            <FaFacebookF className="w-6 h-6" />
          </a>
        );
      }
      if (menuItem.label === 'IG') {
        return (
          <a
            key={menuItem.id}
            href={menuItem.url ?? undefined}
            style={{ color }}
            target="_blank"
            rel="noopener noreferrer"
            className="border-b-0"
          >
            <FaInstagram className="w-6 h-6" />
          </a>
        );
      }
      return null;
    })
  );
  return (
    <Flex
      justify="flex-end"
      align="center"
      className={tw(
        'pt-1 w-full hidden lg:flex h-topmenu',
        colorContext.theme === 'institute'
          ? 'bg-primaryInstitute'
          : 'bg-primaryMain'
      )}
    >
      <Stack
        isInline
        className="justify-end hidden w-full pr-12 mx-auto space-x-10 lg:flex xxl:space-x-16 max-w-screen-xxl"
        align="center"
      >
        {serializedLinks}
        {props.showSnipcart && <Cart />}
        <Flex justify="flex-end" align="center" className="space-x-4">
          {serializedSocialLinks}
        </Flex>
      </Stack>
    </Flex>
  );
};

export default TopMenu;
